import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { WatchlistAddInstrument } from '~/components/watchlist/watchlist-add-instrument.tsx';
import { WatchlistCards } from '~/components/watchlist/watchlist-cards.tsx';
import { getWatchlistPageDataQueryOptions } from '~/server/watchlist/watchlist-page-data-query.ts';
import { cn } from '~/utils/cn.ts';

export const Route = createFileRoute('/watchlists/$watchlistIndex/overview')({
	component: WatchlistOverviewPage,
});

function WatchlistOverviewPage() {
	const { watchlistIndex } = Route.useParams();
	const { data: loaderData } = useSuspenseQuery(
		getWatchlistPageDataQueryOptions({ watchlistIndex: Number(watchlistIndex) }),
	);
	const watchlist = loaderData.watchlists[loaderData.watchlistIndex];
	const isValidWatchlist = Boolean(watchlist);

	return (
		<div className="relative">
			<div
				className={cn(
					'grid auto-rows-min grid-cols-1 gap-1 py-1',
					'md:grid-cols-2 md:gap-2 2xl:grid-cols-3 2xl:gap-3',
					'3xl:grid-cols-4 3xl:gap-3',
				)}
			>
				{isValidWatchlist ? <WatchlistCards userLocale={loaderData.userLocale} watchlist={watchlist} /> : null}
			</div>

			{isValidWatchlist ? <Outlet /> : null}

			<div className="absolute right-2 bottom-2 z-40">
				<div className="flex flex-row items-center gap-x-2">
					{isValidWatchlist ? <WatchlistAddInstrument watchlist={watchlist} /> : null}
				</div>
			</div>
		</div>
	);
}
